// extracted by mini-css-extract-plugin
module.exports = {"btn":"_1OK1uUWrOjKZSobB0SXjPo","icon":"_1l5AhJtDVHp2vcbdfRpOkg"};